import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createExportJobFromFilters } from "@/features/exports/api/createFromFilters";
import { exportKeys } from "@/lib/query/keys";
import type { CreateExportJobFromFiltersRequest } from "@/types/api";

export function useCreateExportFromFilters() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateExportJobFromFiltersRequest) =>
      createExportJobFromFilters(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: exportKeys.all });
    },
  });
}
